"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = index;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireDefault(require("react"));
var _Title = _interopRequireDefault(require("../../Title"));
var _FlexTabContainer = _interopRequireDefault(require("../../FlexTabContainer"));
var _PriceSet = _interopRequireDefault(require("../PriceSet"));
var _classnames = _interopRequireDefault(require("classnames"));
var _AccordionCommon = _interopRequireDefault(require("./AccordionCommon"));
var _Render = _interopRequireDefault(require("./Render"));
var TabPane = _FlexTabContainer["default"].TabPane;
function index(props) {
  var flexTitle = props.flexTitle,
    style = props.style,
    description = props.description,
    _a = props.configuration,
    configuration = _a === void 0 ? [] : _a;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "price-set-tab-container",
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "price-set-tab-wrap"
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle,
    desc: description
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "price-set-tab-main"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "price-set-main-pc"
  }, /*#__PURE__*/_react["default"].createElement(_FlexTabContainer["default"], null, configuration === null || configuration === void 0 ? void 0 : configuration.map(function (item, i) {
    var _a = item,
      title = _a.title,
      key = _a.key,
      _b = _a.list,
      list = _b === void 0 ? [] : _b;
    var compatibleArr = list;
    return /*#__PURE__*/_react["default"].createElement(TabPane, {
      key: i,
      tabIndex: key,
      title: title
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('price-set-item', {
        noTab: (configuration === null || configuration === void 0 ? void 0 : configuration.length) <= 1
      }, {
        isShow: key !== 1
      }),
      key: i
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-set-tab-main-list-wrap"
    }, compatibleArr === null || compatibleArr === void 0 ? void 0 : compatibleArr.map(function (items, index) {
      var _a = items || {},
        isAcross = _a.isAcross,
        _b = _a.itemList,
        itemList = _b === void 0 ? [] : _b;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (itemList === null || itemList === void 0 ? void 0 : itemList.length) > 0 ? (/*#__PURE__*/_react["default"].createElement(_PriceSet["default"], {
        configuration: itemList,
        isAcross: isAcross,
        key: index,
        tab: true
      })) : null);
    }))));
  })))), /*#__PURE__*/_react["default"].createElement("section", {
    className: 'price-set-tab-main-mo'
  }, /*#__PURE__*/_react["default"].createElement(_AccordionCommon["default"]
  // defaultExplore={true}
  // className={'accordion-card-less'}
  , {
    // defaultExplore={true}
    // className={'accordion-card-less'}
    render: function render(props) {
      return /*#__PURE__*/_react["default"].createElement(_Render["default"], {
        item: props
      });
    },
    configuration: configuration
  }))));
}